var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _polygon2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundpocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st455{fill:#FFFFFF;}\n\t.st454{fill:#FFFFFF;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\n\t.st453{fill:#FFFFFF;stroke:#000000;stroke-width:1.16;stroke-miterlimit:10;}\n\t.st452{fill:#FFFFFF;stroke:#000000;stroke-width:0.51;stroke-miterlimit:10;stroke-dasharray:1.53;}\n\t.st451{fill:#FFFFFF;stroke:#010101;stroke-width:3.15;stroke-miterlimit:10;}\n\t.st450{fill:#FFFFFF;stroke:#000000;stroke-width:1.19;stroke-miterlimit:10;}\n\t.st449{fill:none;stroke:#000000;stroke-width:0.52;stroke-miterlimit:10;}\n\t.st448{fill:none;stroke:#000000;stroke-width:0.52;stroke-miterlimit:10;stroke-dasharray:1.59,1.59;}\n\t.st447{fill:none;stroke:#000000;stroke-width:0.52;stroke-miterlimit:10;stroke-dasharray:1.55,1.55;}\n\t.st446{fill:none;stroke:#000000;stroke-width:0.52;stroke-miterlimit:10;stroke-dasharray:1.57,1.57;}\n\t.st445{fill:none;stroke:#000000;stroke-width:0.52;stroke-miterlimit:10;stroke-dasharray:1.58,1.58;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 327.8,
    className: "st455",
    width: 154.4,
    height: 27.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M157.2,206.2c-4.2,20.5-18.4,33.3-42.2,37.9c-3,0.6-6,0.8-9,0.8c-13.1,0-25.6-4.9-34.2-8.4 c2.6-16,5.2-30.1,7.5-41.9v-0.1c8.2,2.1,19.1,4.7,32.1,6.8c2.9,0.5,10.4,1.7,21,2.9l-0.2,9.4l10.9,0.2l0.2-8.5 C147.6,205.6,152.2,205.9,157.2,206.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M59.4,351.3l0.7-14.7c0.7-9.7,1.5-19.5,2.6-29.6c2.4-24.3,5.4-46.4,8.4-65.8c8.9,3.7,21.5,8.4,34.9,8.4 c3.3,0,6.6-0.3,9.8-0.9c18.6-3.6,40.6-13.9,46.1-42.1l4.1,0.2c14.6,0.6,28,0.3,39.2,0.1c1.9,0,3.9-0.1,6.1-0.1V234l-0.5,121.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M157.2,206.2c1.5,0.1,3.1,0.2,4.7,0.2c-5.5,28.3-27.5,38.5-46.1,42.1c-3.2,0.7-6.5,1-9.8,0.9 c-13.4,0-26-4.7-34.9-8.4c0.2-1.6,0.5-3.1,0.7-4.6c8.6,3.5,21.1,8.4,34.2,8.4c3,0,6-0.2,9-0.8C138.8,239.5,152.9,226.8,157.2,206.2z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M211.4,206.6v0.2l-0.1,15v0.4c0,4,0,8,0,12L211.4,206.6C211.4,206.6,211.4,206.6,211.4,206.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M351.4,240.5c-8.6,3.6-21.5,8.8-35,8.8c-3,0-6-0.2-9-0.8c-25.5-4.9-39.9-19.1-43-42.1 c5.6-0.2,11.3-0.6,17.3-1.1l0.2,8.6l10.9-0.2l-0.2-9.4c6.8-0.8,13.8-1.7,21-3c11.9-2,22.1-4.3,29.8-6.2 C345.9,207.7,348.7,223,351.4,240.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M211.7,335L211.7,335c0.9,0,1.8,0.1,2.7,0.1c14.3,0,26.3-10.8,27.6-25V206.9c5.7,0,11.6-0.1,17.7-0.3 c4.1,31.5,27.3,42.6,46.8,46.4c3.2,0.6,6.5,0.9,9.8,0.9c13.9,0,26.8-5,35.7-8.8c2.8,18.4,5.5,39,7.7,61.4c1.7,16.9,3,33.1,3.8,48.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M242.1,206.9V310c-1.4,14.2-13.3,25.1-27.6,25c-0.9,0-1.8-0.1-2.7-0.2c-0.1-37.6-0.2-75.2-0.4-112.8v-0.4 c0-5,0-10.1,0-15.1v-0.1c0,0,0.1,0,0.1,0h1.1c2.6,0.1,5.1,0.1,7.4,0.1C226.8,206.9,234.2,207,242.1,206.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M352.1,245.2c-9,3.8-21.9,8.8-35.7,8.8c-3.3,0-6.6-0.3-9.8-0.9c-19.5-3.8-42.8-14.9-46.8-46.4l4.6-0.2 c3,23,17.5,37.2,43,42.1c3,0.6,6,0.8,9,0.8c13.5,0,26.4-5.2,35-8.8C351.7,242,351.9,243.6,352.1,245.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st453",
    d: "M242.1,206.9V310c-1.4,14.2-13.3,25.1-27.6,25c-0.9,0-1.8-0.1-2.7-0.2l-0.5,0V206.6c0,0,0.1,0,0.1,0h1.1 c2.6,0.1,5.1,0.1,7.4,0.1C226.8,206.9,234.2,207,242.1,206.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M214.4,333.5c-0.6,0-1.1,0-1.6-0.1V208.2c2.5,0.1,4.9,0.1,7.1,0.1c6.4,0.1,12.6,0.2,19.1,0.2h1.6V310 C239.2,323.4,227.9,333.6,214.4,333.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M133.1,173.4l-0.5,22.5l-0.2,8.2c-10.6-1.2-18.1-2.4-21-2.9c-13-2.1-24-4.7-32.1-6.8l-1.7-0.4 c2.6-9.3,5.2-18.5,7.7-27.8L133.1,173.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M211.3,206.6L211.3,206.6c-2.2,0.1-4.2,0.2-6.1,0.2c-11.2,0.2-24.5,0.5-39.2-0.1l-4.1-0.2 c-1.6-0.1-3.1-0.1-4.7-0.2c-4.9-0.3-9.6-0.6-13.9-1l0.2-8.5l0.5-21.7l2.6,0.4c11.8,1.3,23.6,1.9,35.5,1.7c-1,7.3-1.3,14.8-0.7,22.2 c0.1,1.9,0.3,3.8,0.5,5.7C193.1,206,203,206.4,211.3,206.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M212.5,206.6h-1.2v-0.1c0,0,0.1,0,0.1,0C211.7,206.6,212.1,206.6,212.5,206.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M242.6,177.2c-10.2-0.1-20.2-0.6-30.1-1.1c10.2-0.6,20.2-1.2,30-1.5C242.6,175.4,242.6,176.3,242.6,177.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st450",
    points: "144,170.8 143.9,173.2 143.5,195.9 143.2,204.8 143.1,213.7 132.2,213.5 132.4,203.6 132.6,195  133.1,171.4 133.1,170.6 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M281.7,205.3c-6,0.5-11.8,0.9-17.3,1.1l-4.6,0.2c-6.2,0.2-12.1,0.3-17.7,0.3c-7.8,0-15.3-0.1-22.2-0.2 c-2.3,0-4.7-0.1-7.4-0.1h-1.1c0,0-0.1,0-0.1,0c-8.2-0.2-18.2-0.6-29.4-1.4c-0.2-1.9-0.4-3.8-0.5-5.7c-0.6-7.4-0.3-14.8,0.7-22.2 c0.1-0.9,0.3-1.8,0.4-2.6c9.8,0.3,19.8,1,30,1.5l0,0c9.9,0.6,19.9,1,30.1,1.1c12,0.2,24-0.4,35.9-1.7l2.6-0.4l0.5,21.2L281.7,205.3z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M347.3,194l-4,1c-7.6,1.9-17.8,4.2-29.8,6.2c-7.3,1.2-14.3,2.2-21,3l-0.2-8.7l-0.5-22l47.8-7.3 C342.2,175.5,344.7,184.7,347.3,194z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st450",
    points: "292.8,213.6 281.9,213.8 281.7,204.8 281.5,195.4 281,173.1 281,170.8 291.9,170.6 291.9,171.3  292.4,194.5 292.5,203.7 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st455",
    d: "M161.9,206.4c-5.6,28.3-27.6,38.5-46.1,42.1c-3.2,0.7-6.5,1-9.8,0.9c-13.4,0-26-4.7-34.9-8.4 c0.2-1.6,0.5-3.1,0.7-4.6c8.6,3.5,21.1,8.4,34.2,8.4c3,0,6-0.2,9-0.8c23.8-4.6,38-17.4,42.2-37.9 C158.7,206.3,160.2,206.4,161.9,206.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st455",
    d: "M106,248.4c-12.4,0-24-4-33.7-8l0.4-2.5c7.5,3.1,20.2,8,33.3,8c3.1,0,6.1-0.3,9.2-0.8 c23.9-4.6,38.4-17.4,42.9-37.8l2.5,0.1c-5.8,27.1-27.6,36.8-45,40.1C112.4,248.2,109.2,248.5,106,248.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M73,240.8l-0.7-0.3l0.1-0.8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M72.5,238.7l0.1-0.8l0.7,0.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st448",
    d: "M74.8,238.8c7.6,3.1,19.2,7.1,31.1,7.1c3.1,0,6.1-0.3,9.2-0.8c23.3-4.5,37.6-16.7,42.5-36.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M157.9,208.1c0.1-0.2,0.1-0.5,0.2-0.8h0.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M159.8,207.4h0.8c0,0.3-0.1,0.5-0.2,0.8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st447",
    d: "M160,209.7c-6.6,25.3-27.6,34.6-44.5,37.8c-3.2,0.6-6.4,0.9-9.6,0.9c-11.8,0-22.8-3.6-32.3-7.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st455",
    d: "M352.1,245.2c-9,3.8-21.9,8.8-35.7,8.8c-3.3,0-6.6-0.3-9.8-0.9c-19.5-3.8-42.8-14.9-46.8-46.4l4.6-0.2 c3,23,17.5,37.2,43,42.1c3,0.6,6,0.8,9,0.8c13.5,0,26.4-5.2,35-8.8C351.7,242,351.9,243.6,352.1,245.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st455",
    d: "M316.4,252.9c-3.2,0-6.4-0.3-9.6-0.9c-18.6-3.6-41.4-14.2-45.9-44.4l2.5-0.1c3.4,22.9,18.1,37.1,43.7,42 c3,0.6,6.1,0.8,9.2,0.8c13.2,0,26-5,34.2-8.4l0.4,2.5C340.9,248.7,329,252.9,316.4,252.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M261.1,208.4l-0.1-0.8h0.8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M262.7,207.5h0.8c0,0.3,0.1,0.5,0.1,0.8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st446",
    d: "M263.9,209.8c4.1,21.6,18.6,34.9,43.3,39.7c3,0.6,6.1,0.8,9.2,0.8c12.5,0,24.6-4.4,32.7-7.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M349.8,242.3l0.7-0.3c0,0,0,0.3,0.1,0.8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M350.8,243.8c0,0.3,0.1,0.6,0.1,0.8l-0.7,0.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M348.8,245.4c-9.6,3.9-20.7,7.5-32.4,7.5c-3.2,0-6.4-0.3-9.6-0.9c-18.2-3.5-40.6-13.8-45.5-42.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundpocket);
export default __webpack_public_path__ + "static/media/ROUND POCKET.6d96f8ed4799d3ac3217f660e90a6d0c.svg";
export { ForwardRef as ReactComponent };